<template>
    <div :class="['loading-state', layoutOrientation === 'horizontal' ? 'horizontal-layout' : 'vertical-layout']">
        <LoadingSpinner :icon="spinnerIcon" />
        <span class="loading-text">
            {{ text }}
        </span>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import LoadingSpinner from "@/components/loading/LoadingSpinner.vue";

import type { Orientation } from "@/types/orientations";

export default defineComponent({
    components: {
        LoadingSpinner,
    },
    name: "LoadingState",
    props: {
        text: {
            type: String,
            default: "Loading",
        },
        layoutOrientation: {
            type: String as PropType<Orientation>,
            default: "horizontal",
        },
        spinnerIcon: String as PropType<string>,
    },
});
</script>

<style scoped>
@import "@/style/components/loading.css";
</style>
